<template>
<div class="chapter">
<div class="inner_page">
<section class="chapter" epub:type="chapter" id="structure" role="doc-chapter">
<figure class="figure" id="struc">
<p class="fig"><span aria-label="xiv" class="page" epub:type="pagebreak" id="pxiv" role="doc-pagebreak"></span><img alt="" height="600" src="images/chi-Mitchell-EX000-REPLACEMENT-8-8-22.jpeg" width="394"/></p>
</figure>
</section>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chi-mitchell-0008.vue?9cf518a0